import appConfig from "../appconfig";
import {BifrostBackendApi} from "../gateways/BifrostBackendApi";
import ProductsIngredientsProvider from "./ProductsIngredientsProvider";

const IngredientsProvider = Object.freeze({
	getIngredients(skipCounter) {
		const ingredientsQueryParams = {
			tenantId: appConfig.tenantId,
			$skip: skipCounter
		};

		return Promise.all([
			BifrostBackendApi.get("/ingredients", {
				params: ingredientsQueryParams
			})
		]).then(([ ingredientsResponse]) => {
			return {
				ingredientsResponse
			};
		});
	},
	updateIngredient(ingredient, jwtToken) {
		return BifrostBackendApi.put(`/ingredients/${ingredient.id}?tenantId=${ingredient.tenantId}`, ingredient, {
			headers: {
				Authorization: jwtToken
			}
		});
	},
	createIngredient(ingredient, jwtToken){
		return BifrostBackendApi.post(`/ingredients/?tenantId=${ingredient.tenantId}`, ingredient, {
			headers: {
				Authorization: jwtToken
			}
		});
	},
	getIngredient(ingredientId, tenantId, jwtToken) {
		return BifrostBackendApi.get(`/ingredients/${ingredientId}?tenantId=${tenantId}`, {
			headers: {
				Authorization: jwtToken
			}
		});
	},
	deleteIngredient(ingredient, jwtToken) {
		return BifrostBackendApi.delete(`/ingredients/${ingredient.id}?tenantId=${ingredient.tenantId}`, {
			headers: {
				Authorization: jwtToken
			}
		});
	},
	deleteIngredientAndProductIngredients(ingredient, jwtToken) {
		return Promise.all([
			ProductsIngredientsProvider.deleteProductsIngredients(ingredient, jwtToken),
			BifrostBackendApi.delete(`/ingredients/${ingredient.id}?tenantId=${ingredient.tenantId}`, {
				headers: {
					Authorization: jwtToken
				}
			})
		]).then(([ productsIngredients, ingredient]) => {
			return {
				productsIngredients,
				ingredient
			};
		});
	}
});

export default IngredientsProvider;
